import { render, staticRenderFns } from "./newCourseList.vue?vue&type=template&id=3c0b399f&"
import script from "./newCourseList.vue?vue&type=script&lang=js&"
export * from "./newCourseList.vue?vue&type=script&lang=js&"
import style0 from "./newCourseList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports